function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon_atm",
  transform: "translate(-977.39 -976.682)"
}, React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M1047.5,994.758a1.1,1.1,0,0,1-2.193,0V978.873H979.581v20.449h6.687a1.1,1.1,0,0,1,0,2.191h-7.783a1.1,1.1,0,0,1-1.1-1.1V977.777a1.1,1.1,0,0,1,1.1-1.1H1046.4a1.1,1.1,0,0,1,1.1,1.1v16.98Zm-8.88,6.756h7.783a1.1,1.1,0,1,0,0-2.191h-7.783a1.1,1.1,0,1,0,0,2.191Z",
  transform: "translate(0 0)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M982.826,983.833a1.1,1.1,0,1,1,0-2.191h48.109a1.1,1.1,0,1,1,0,2.191Z",
  transform: "translate(5.565 6.36)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M993.971,984.122a1.1,1.1,0,1,1,0,2.191h-8.81v20.452h40.258V986.313h-3.857a1.1,1.1,0,1,1,0-2.191h4.955a1.1,1.1,0,0,1,1.1,1.1v22.643a1.1,1.1,0,0,1-1.1,1.1H984.065a1.1,1.1,0,0,1-1.1-1.1V985.218a1.1,1.1,0,0,1,1.1-1.1Zm22.638,0H998.923a1.1,1.1,0,1,0,0,2.191h17.685a1.1,1.1,0,1,0,0-2.191Z",
  transform: "translate(7.155 9.54)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M984.065,998.405a1.1,1.1,0,0,1,0-2.193h42.451a1.1,1.1,0,0,1,0,2.193Z",
  transform: "translate(7.155 25.044)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M984.065,1000.575a1.1,1.1,0,0,1,0-2.193h42.451a1.1,1.1,0,0,1,0,2.193Z",
  transform: "translate(7.155 27.826)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M987.31,985.218a1.1,1.1,0,1,1,2.191,0,10.227,10.227,0,0,0,17.453,7.235l0,0,0,0a10.187,10.187,0,0,0,2.995-7.23,1.1,1.1,0,0,1,2.193,0,12.386,12.386,0,0,1-3.636,8.78l0,0a12.412,12.412,0,0,1-21.191-8.778Z",
  transform: "translate(12.721 9.54)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M984.065,992.514a1.1,1.1,0,1,1,0-2.191,9.585,9.585,0,0,1,9.586,9.586,1.1,1.1,0,0,1-2.191,0,7.395,7.395,0,0,0-7.395-7.395Z",
  transform: "translate(7.155 17.492)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M1007.436,990.323a1.1,1.1,0,1,1,0,2.191,7.366,7.366,0,0,0-5.229,2.161l-.007,0a7.363,7.363,0,0,0-2.159,5.229,1.1,1.1,0,0,1-2.191,0,9.569,9.569,0,0,1,2.805-6.774l.007,0A9.562,9.562,0,0,1,1007.436,990.323Z",
  transform: "translate(26.236 17.492)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}));

var SvgIconAtm = function SvgIconAtm(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70.113,
    height: 51.72,
    viewBox: "0 0 70.113 51.72",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconAtm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_atm.4de835ed.svg";
export { ForwardRef as ReactComponent };